import React from 'react'
import { withComponentContext } from 'widgets-shared/core'
import { withTranslations } from 'widgets-shared/core'
import { Typography } from  '@mui/material'
import { compose } from 'widgets-shared/core'

import { PropTranslations } from 'smartstream-widgets/types/widget'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import Disclaimer from 'smartstream-widgets/controls/Disclaimer/Disclaimer'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'
import { withComponentContextProvider } from 'widgets-shared/core'

type Props = {
  classes: {
    [K in string]: string
  },
  config: {
    BASE_ASSET_PATH: string,
    clickInteraction?: "cta" | "markets"
  },
  disclaimer: string,
  footerLink?: string,
  translations: PropTranslations,
  isSingleFixture: boolean
}

const styles = (theme: Theme) => createStyles({
  disclaimer: {
    color: theme.palette.text.secondary,
  },
  poweredBy: {
    alignItems: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    fontSize: 9,
    justifyContent: 'center',
    padding: `${theme.spacing(1)} ${theme.spacing(1)} 7px`,
    fontFamily: 'Klarheit Kurrent'
  },
  poweredByLogo: {
    height: 15
  },
  root: {
    bottom: 10,
    left: 0,
    position: 'absolute',
    width: '100%',
    height: 24,
    overflow: 'hidden'
  }
})

function PredictedScoreFooter(props: Props) {
  const {
    classes,
    config: {
      BASE_ASSET_PATH = '',
      clickInteraction
    },
    disclaimer,
    footerLink,
    translations,
    isSingleFixture
  } = props
  
  return (
    <footer className={classes.root}>
      {
        clickInteraction === 'markets' && disclaimer &&
        <Disclaimer
          disclaimer={disclaimer}
          footerLink={footerLink}
          classes={{ disclaimerText: classes.disclaimer }}
          isSingleFixture={isSingleFixture}
        />
      }
      {
        clickInteraction !== 'markets' &&
        <Typography align='center' className={classes.poweredBy}>
          <img
            className={classes.poweredByLogo}
            src={`${BASE_ASSET_PATH}/img/genius-sports-logos/genius-sports-logo-marque-light.svg`}
            alt='Genius Sports' /> {translations.poweredBy}
        </Typography>
      }
    </footer>
  )
}

const PredictedScoreFooterComposed = compose(
  withComponentContext,
  withStyles(styles, { name: 'PredictedScoreFooter', defaultTheme: getDefaultTheme }),
  withTranslations((t: TranslationFunction) => {
    return {
      poweredBy: t('poweredBy.translation', {
        defaultValue: 'Powered by Genius Sports',
        context: 'Text to indicate authoring, besides the Genius Sports logo, at the bottom of the Predicted Score widget'
      })
    }
  })
)(PredictedScoreFooter) as React.ElementType

export default PredictedScoreFooterComposed

export const PredictedScoreFooterWithContext = withComponentContextProvider(PredictedScoreFooterComposed) as React.Component
